document.addEventListener('DOMContentLoaded', function () {
    // Función para verificar si es móvil
    function isMobile() {
      return window.innerWidth <= 768;
    }
  
    // Inicializar funciones según la clase del cuerpo
    function initPageFunctions() {
      const bodyClass = document.body.classList;
  
      // Inicializar funciones para PDP
      if (bodyClass.contains('template-product')) {
        initShopTheLookAddToCart();
        if (isMobile()) {
          // aca funciones para mobile
        }
      }
      // Inicializar funciones para PLP
      if (bodyClass.contains('template-collection')) {
        if (!isMobile()) {
          waitForSwatchKing().then(() => {
            initSwatchVariantMonitor();
          });
        }
      }
      if (bodyClass.contains('template-search')) {
        if (!isMobile()) {
          waitForSwatchKing().then(() => {
            initSwatchVariantMonitor();
          });
        }
      }
      if (document.querySelector('.footer-promotions')) {
        if (isMobile()) {
            initMobileCarousel();
        }
      }
    }
  
    // Inicializar el carrusel móvil
    function initMobileCarousel() {
      var elem = document.querySelector('.grid.grid--flush-bottom');
      if (elem) {
        var flkty = new Flickity(elem, {
          cellAlign: 'center',
          contain: true,
          wrapAround: true,
          pageDots: true,
          prevNextButtons: false,
          lazyLoad: 1,
          adaptiveHeight: true,
          autoPlay: false,
        });
      }
    }
  
    // Inicializar Shop the Look Add to Cart
    function initShopTheLookAddToCart() {
      const addToCartForms = document.querySelectorAll('form.add-to-cart-form');
      addToCartForms.forEach((form) => {
        form.addEventListener("submit", async (event) => {
          // Prevent normal submission
          event.preventDefault();
  
          // Get the submit button
          const submitButton = form.querySelector('button[type="submit"]');
          const originalButtonText = submitButton.textContent;
  
          // Show loader
          submitButton.disabled = true;
          submitButton.textContent = 'Agregando...';
          submitButton.classList.add('btn--loading');
  
          try {
            // Submit form with ajax
            const response = await fetch("/cart/add", {
              method: "post",
              body: new FormData(form),
            });
  
            if (!response.ok) {
              throw new Error('Error al agregar al carrito');
            }
  
            // Get new cart object
            const res = await fetch("/cart.json");
            const cart = await res.json();
  
            // Update cart count
            document.querySelectorAll(".cart-count").forEach((el) => {
              el.textContent = cart.item_count;
            });
  
            // Change button text to "Añadido" temporarily
            submitButton.textContent = 'Añadido';
            setTimeout(() => {
              submitButton.textContent = originalButtonText;
              submitButton.disabled = false;
            }, 2000); // Change back after 2 seconds
          } catch (error) {
            console.error('Error al agregar al carrito:', error);
            // Reset button in case of error
            submitButton.disabled = false;
            submitButton.textContent = originalButtonText;
          } finally {
            // Remove loading class
            submitButton.classList.remove('btn--loading');
          }
        });
      });
    }
    function waitForSwatchKing() {
      return new Promise((resolve) => {
        const checkSwatchKing = () => {
          const swatchElements = document.querySelectorAll('[swatch-generated]');
          if (swatchElements.length > 0) {
            console.log('Swatch King ha terminado de cargar');
            resolve();
          } else {
            setTimeout(checkSwatchKing, 100); // Verificar cada 100ms
          }
        };
        checkSwatchKing();
      });
    }

    function initSwatchVariantMonitor() {
      const gridItems = document.querySelectorAll('.grid-product');
      //console.log(gridItems);

      gridItems.forEach(item => {
        const observer = new MutationObserver(mutations => {
          mutations.forEach(mutation => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'swatch-generated') {
              const newValue = item.getAttribute('swatch-generated');
              //console.log(newValue);
              if (newValue) {
                fetchVariantSizes(newValue, item);
              }
            }
          });
        });
  
        observer.observe(item, { attributes: true });
      });
    }
  
      // Función para obtener las variantes de talle disponibles
  async function fetchVariantSizes(handle, gridItem) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      
      const productData = await response.json();
      //console.log('Datos del producto:', productData);
  
      const availableSizes = productData.variants
        .filter(variant => variant.available)
        .map(variant => variant.option1)
        .filter(Boolean);
        
      const allSizes = productData.variants
        .map(variant => variant.option1)
        .filter(Boolean);
  
      //console.log('Tallas disponibles:', availableSizes);
      //console.log('Todas las tallas:', allSizes);
  
      updateSizeAvailability(gridItem, availableSizes, allSizes);
    } catch (error) {
      console.error('Error al obtener las variantes:', error);
    }
  }
  
      // Función para actualizar la disponibilidad de tallas en el grid item
  function updateSizeAvailability(gridItem, availableSizes, allSizes) {
    //console.log('Actualizando tallas para:', gridItem, 'Tallas disponibles:', availableSizes);
    
    const quickProductBtn = gridItem.querySelector('.quick-product__btn');
    const quickProductLabel = gridItem.querySelector('.quick-product__label');
    const productAvailability = gridItem.querySelector('.product-availability');
    const soldOutTag = gridItem.querySelector('.grid-product__tag--sold-out');
    
    if (!quickProductBtn || !quickProductLabel || !productAvailability) {
      console.error('No se encontraron los elementos necesarios del producto');
      return;
    }

    const hasAvailableSizes = availableSizes.length > 0;
    
    if (hasAvailableSizes) {
      // Producto con stock disponible
      quickProductLabel.innerHTML = 'VISTA RÁPIDA<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-bag-minimal" viewBox="0 0 64 64"><path stroke="null" id="svg_4" fill-opacity="null" stroke-opacity="null" fill="null" d="M11.375 17.863h41.25v36.75h-41.25z"></path><path stroke="null" id="svg_2" d="M22.25 18c0-7.105 4.35-9 9.75-9s9.75 1.895 9.75 9"></path></svg>';
      
      // Ocultar tag de "Agotado" si existe
      if (soldOutTag) {
        soldOutTag.style.display = 'none';
      }
      
      // Crear estructura de tallas si no existe
      let variantList = productAvailability.querySelector('.variant-values');
      if (!variantList) {
        productAvailability.innerHTML = `
          <span class="availability-label">Disponible en:</span>
          <div class="variant-group">
            <span class="variant-values"></span>
          </div>
        `;
        variantList = productAvailability.querySelector('.variant-values');
      }
      
      // Limpiar y crear elementos para TODAS las tallas
      variantList.innerHTML = '';
      const availableSizesSet = new Set(availableSizes);
      
      // Usar un Set para evitar duplicados y mantener orden
      const uniqueSizes = [...new Set(allSizes)];
      
      uniqueSizes.forEach(size => {
        const sizeElement = document.createElement('span');
        sizeElement.textContent = size;
        
        if (availableSizesSet.has(size)) {
          sizeElement.className = 'variant-item in-stock';
        } else {
          sizeElement.className = 'variant-item out-of-stock';
        }
        
        variantList.appendChild(sizeElement);
      });
      
    } else {
      // Producto sin stock
      quickProductLabel.textContent = 'Producto Agotado';
      productAvailability.innerHTML = '<span class="out-of-stock-message">Notificarme cuando vuelva a stock!</span>';
      
      // Mostrar tag de "Agotado" si existe
      if (soldOutTag) {
        soldOutTag.style.display = 'block';
      }
    }
  }
    
  
    // Ejecutar funciones de inicialización
    initPageFunctions();
  });
